<template>
    <div class="goods-container" @click="toGoodsDetail">
        <div class="goods-img">
            <el-image fit="cover" style="width: 100%; height: 166px" :src="goodsInfo.image && goodsInfo.image.length > 0 ? goodsInfo.image[0] : ''"
                ></el-image>
        </div>
        <div class="goods-remark">{{ goodsInfo.name }}</div>
        <div class="goods-price-sales">
            <div class="goods-price">¥{{ goodsInfo.min_price }}</div>
            <div class="goods-sales">{{ goodsInfo.sell_count }}+销量</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            goodsInfo: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {}
        },
        methods: {
            toGoodsDetail() {
                this.$emit('toDetail',this.goodsInfo)
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/styles/var.less";
    @import "~@/styles/mixin.less";
    .goods-container {
        width: 100%;
    }

    .goods-img {
        width: 100%;
        height: 166px;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
    }

    .goods-container img {
        width: 100%;
        height: 100%;
    }

    .goods-remark {
        width: 100%;
        font-size: 14px;
        font-weight: 600;
        color: @words;
        margin-top: 9px;
        height:40px;
        cursor: pointer;
        .line-clamp()
    }

    .goods-price-sales {
        margin-top: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .goods-price {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #FF6F00;
        line-height: 25px;
    }

    .goods-sales {
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: #D6D6D6;
        line-height: 17px;
    }
</style>